export default function Pattern(props) {
    return (
        <div className={'absolute w-full h-full top-0 left-0 bg-cover bg-center bg-no-repeat bg-fixed ' + (props.className || '')} style={{ backgroundImage: 'url(/assets/images/background/pattern-opacity.png)' }} />
    );
}